// /substitutions — замещения: действующие, запланированные, закончившиеся. Право —
// substitutions.read: администратор видит все, владелец и заместитель — свои.
import { createFileRoute, useNavigate } from '@tanstack/react-router';
import { useCallback } from 'react';
import { SubstitutionsPage } from '../../../features/substitutions/SubstitutionsPage.tsx';
import { parseSubstitutionsSearch } from '../../../features/substitutions/search.ts';
import type { SubstitutionsSearch } from '../../../features/substitutions/search.ts';
import { requireSection } from '../../../shell/permissions.ts';

export const Route = createFileRoute('/_app/_settings/substitutions')({
  validateSearch: parseSubstitutionsSearch,
  beforeLoad: requireSection('substitutions'),
  staticData: { crumb: 'Замещения' },
  component: SubstitutionsRoute,
});

function SubstitutionsRoute() {
  const search = Route.useSearch();
  const navigate = useNavigate();
  const onSearchChange = useCallback(
    (next: SubstitutionsSearch) =>
      void navigate({ to: '/substitutions', search: next, replace: true }),
    [navigate],
  );
  return <SubstitutionsPage search={search} onSearchChange={onSearchChange} />;
}
